module.exports = __webpack_public_path__ + "img/spinner.2f6bf996.svg";